import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { addTimingMeasureInstructionsToAction } from 'utils/timing';
import {
  selectAccountId,
  selectAccountMetaSynced,
} from 'reducers/account/meta';
import { REPLACE_ACCOUNT_META } from 'constants/account/meta';
import { syncFirebasePath } from 'sagas/firebase/internal-lib';
import { CANCEL_ACCOUNT_SYNC } from 'constants/actionTypes';
import { FETCH_ACCOUNT_CONTENT_STATUS } from 'constants/account/contentStatus';
import { selectAccountContentStatusMeta } from 'reducers/account/contentStatus';
import {
  setAccountContentStatusErrored,
  setAccountContentStatusFetching,
  replaceAccountContentStatus,
} from 'actions/account/contentStatus';

function* replaceAccountContentStatusSaga(data) {
  yield put(
    addTimingMeasureInstructionsToAction(
      replaceAccountContentStatus(data),
      FETCH_ACCOUNT_CONTENT_STATUS
    )
  );
}

export function* fetchAccountContentStatusSaga(/* action */) {
  try {
    const accountMetaSynced = yield select(selectAccountMetaSynced);

    if (!accountMetaSynced) {
      yield take(REPLACE_ACCOUNT_META);
    }

    const accountId = yield select(selectAccountId);
    const accountContentStatusMeta = yield select(
      selectAccountContentStatusMeta
    );
    const { fetching, synced, errored } = accountContentStatusMeta;

    if (errored || (!synced && !fetching)) {
      yield put(setAccountContentStatusFetching());

      yield call(
        syncFirebasePath,
        `accounts/${accountId}/content-status`,
        replaceAccountContentStatusSaga,
        CANCEL_ACCOUNT_SYNC
      );
    }
  } catch (error) {
    yield put(setAccountContentStatusErrored(error));
  }
}

export default function* contentStatus() {
  yield takeEvery(FETCH_ACCOUNT_CONTENT_STATUS, fetchAccountContentStatusSaga);
}
